import React from 'react';

const About = ({ title, description }) => {
  return (
    <section id="about" className="section-container">
      <div className="content-wrapper">
        <h2 className="section-title" style={{ textAlign: 'center' }}>{title}</h2>
        <p className="section-description" style={{ textAlign: 'center', margin: '0 auto' }}>{description}</p>
      </div>
    </section>
  );
};

export default About;
